<template>
    <main>
        <!-- breadcrumb area start here -->
        <section class="bd-breadcrumb-area p-relative fix theme-bg">
            <!-- breadcrumb background image -->
            <div class="bd-breadcrumb-bg" :style="{ backgroundImage: 'url(/img/bg/breadcrumb-bg.jpg)' }"></div>
            <div class="bd-breadcrumb-wrapper mb-60 p-relative">
                <div class="container">
                    <div class="bd-breadcrumb-shape d-none d-sm-block p-relative">
                        <div class="bd-breadcrumb-shape-1">
                        </div>
                        <div class="bd-breadcrumb-shape-2">
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-xl-10">
                            <div class="bd-breadcrumb d-flex align-items-center justify-content-center">
                                <div class="bd-breadcrumb-content text-center">
                                    <h1 class="bd-breadcrumb-title">Campus</h1>
                                    <div class="bd-breadcrumb-list">
                                        <span><a href="/"><i class="flaticon-hut"></i>Home</a></span>
                                        <div class="bd-breadcrumb-list">
                                            <span><a href="#">About</a></span>
                                        </div>
                                        <span>Campus</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bd-wave-wrapper bd-wave-wrapper-3">
                <div class="bd-wave bd-wave-3"></div>
                <div class="bd-wave bd-wave-3"></div>
            </div>
        </section>
        <!-- breadcrumb area end here  -->

        <div class="bd-section-title-wrapper text-center mb-55 wow fadeInUp mt-100" data-wow-duration="1s"
            data-wow-delay=".2s"
            style="visibility: visible; animation-duration: 1s; animation-delay: 0.2s; animation-name: fadeInUp;">
            <h2 class="bd-section-title mb-0">Explore VGPS - Inspiring Learning Hub</h2>
            <p>Nestled in the heart of Reengus, Vedanta Gurukul Public School stands as a symbol of excellence
                with its robust infrastructure facilities</p>
        </div>

        <!-- class area start here -->
        <section class="bd-class-area pt-70 pb-70">
            <div class="container">
                <div class="row">
                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class=" fix radius-24 p-relative mb-50 wow fadeInUp" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <div class="bd-class-thumb">
                                <img src="/img/campus/C8.png" alt="class image not found!">
                            </div>
                            <div class=" theme-bg-6">
                                <h3 class="text-center" style="margin: 0;padding:10px;">Vibrant Campus</h3>
                            </div>
                            <div class="theme-bg-2 text-center" style="height: 75px;color:white;padding: 5px;">
                                Lively, colorful and eco-friendly classrooms for a positive learning atmosphere
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class=" fix radius-24 p-relative mb-50 wow fadeInUp" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <div class="bd-class-thumb">
                                <img src="/img/campus/C2.png" alt="class image not found!">
                            </div>
                            <div class=" theme-bg-6 ">
                                <h3 class="text-center" style="margin: 0;padding:10px;">Classrooms</h3>
                            </div>
                            <div class="theme-bg-2 text-center" style="height: 75px;color:white;padding: 5px;">
                                Well-designed classrooms with conducive environment for all students
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class=" fix radius-24 p-relative mb-50 wow fadeInUp" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <div class="bd-class-thumb">
                                <img src="/img/campus/C3.png" alt="class image not found!">
                            </div>
                            <div class=" theme-bg-6">
                                <h3 class="text-center" style="margin: 0;padding:10px;">Computer Lab</h3>
                            </div>
                            <div class="theme-bg-2 text-center" style="height: 75px;color:white;padding: 5px;">
                                Well-equipped computer lab for hands-on digital experience to the students
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class=" fix radius-24 p-relative mb-50 wow fadeInUp" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <div class="bd-class-thumb">
                                <img src="/img/campus/C6.png" alt="class image not found!">
                            </div>
                            <div class=" theme-bg-6">
                                <h3 class="text-center" style="margin: 0;padding:10px;">Library & Reading Room</h3>
                            </div>
                            <div class="theme-bg-2 text-center" style="height: 75px;color:white;padding: 5px;">
                                Provides rich resources for students, fostering the urge and desire for reading and
                                learning
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class=" fix radius-24 p-relative mb-50 wow fadeInUp" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <div class="bd-class-thumb">
                                <img src="/img/campus/C5.png" alt="class image not found!">
                            </div>
                            <div class=" theme-bg-6">
                                <h3 class="text-center" style="margin: 0;padding:10px;">Playground</h3>
                            </div>
                            <div class="theme-bg-2 text-center" style="height: 75px;color:white;padding: 5px;">
                                Range of playground equipments, allowing students to engage in multiple sports
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class=" fix radius-24 p-relative mb-50 wow fadeInUp" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <div class="bd-class-thumb">
                                <img src="/img/campus/C4.png" alt="class image not found!">
                            </div>
                            <div class=" theme-bg-6">
                                <h3 class="text-center" style="margin: 0;padding:10px;">Sports Facilities</h3>
                            </div>
                            <div class="theme-bg-2 text-center" style="height: 75px;color:white;padding: 5px;">
                                Latest sports equipment and high -quality coaching to students ensuring sports
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="fix radius-24 p-relative mb-50 wow fadeInUp" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <div class="bd-class-thumb">
                                <img src="/img/campus/C1.png" alt="class image not found!">
                            </div>
                            <div class="theme-bg-6 ">
                                <h3 class="text-center" style="margin: 0;padding:10px;">Digital Teaching</h3>
                            </div>
                            <div class="theme-bg-2 text-center" style="height: 75px;color:white;padding: 5px;">
                                Embraces eLearning and Digital pedagogy so that students receive interactive education
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class=" fix radius-24 p-relative mb-50 wow fadeInUp" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <div class="bd-class-thumb">
                                <img src="/img/campus/C7.png" alt="class image not found!">
                            </div>
                            <div class=" theme-bg-6">
                                <h3 class="text-center" style="margin: 0;padding:10px;">CCTV Surveillance</h3>
                            </div>
                            <div class="theme-bg-2 text-center" style="height: 75px;color:white;padding: 5px;">
                                We have installed CCTV surveillance across the campus to ensure a secure environment
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class=" fix radius-24 p-relative mb-50 wow fadeInUp" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <div class="bd-class-thumb">
                                <img src="/img/campus/C9.png" alt="class image not found!">
                            </div>
                            <div class=" theme-bg-6">
                                <h3 class="text-center" style="margin: 0;padding:10px;">Creativity & Recreation</h3>
                            </div>
                            <div class="theme-bg-2 text-center" style="height: 75px;color:white;padding: 5px;">
                                We provides creativity and
                                recreational activities that enrich the overall learning experience.
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class=" fix radius-24 p-relative mb-50 wow fadeInUp" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <div class="bd-class-thumb">
                                <img src="/img/campus/C10.png" alt="class image not found!">
                            </div>
                            <div class=" theme-bg-6">
                                <h3 class="text-center" style="margin: 0;padding:10px;">Dance & Music Studio</h3>
                            </div>
                            <div class="theme-bg-2 text-center" style="height: 75px;color:white;padding: 5px;">
                                We encourages students to explore their
                                artistic talents, fostering versatility & creativity.
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </section>
        <!-- class area end here -->


    </main>
</template>
<script>
export default {
    name: "CampusView",
};
</script>
